import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { Select, Store } from '@ngxs/store';
import { AppState, AppStateModel, CloseMobileMenuOpenedAction } from '../../app.state';
import { NavbarComponent } from '../navbar/navbar.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [MatButtonModule, FaIconComponent, NavbarComponent, UserMenuComponent, AsyncPipe],
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent {
  constructor(private _store: Store) {}

  @Select(AppState)
  protected appState$!: Observable<AppStateModel>;

  protected closeMobileMenu() {
    this._store.dispatch(new CloseMobileMenuOpenedAction());
  }

  protected readonly faXmark = faXmark;
}
